import {
  Box,
  Heading,
  Text,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const cards = [
  {
    title: "Reliability",
    body: "We do what we say. Consistent, dependable outreach you can count on — every campaign, every call, every time.",
  },
  {
    title: "Professional Communication",
    body: "Every call is handled with clarity and respect, strengthening your brand reputation with every single interaction.",
  },
  {
    title: "Opportunity Creation",
    body: "Opening doors for new property listings and business growth through strategic, targeted outreach campaigns.",
  },
  {
    title: "Integrity",
    body: "Honest, transparent, and ethical interactions with every landlord, every prospect — no exceptions.",
  },
];

export default function DifferenceSection() {
  return (
    <Box
      id="difference"
      py={{ base: 20, md: 32 }}
      px={{ base: 6, md: 12, lg: 20 }}
      bg="brand.black"
    >
      <Box maxW="1400px" mx="auto">
        {/* Section Header */}
        <MotionBox
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          mb={20}
        >
          <HStack mb={4} spacing={3}>
            <Box w="32px" h="1px" bg="brand.coral" />
            <Text
              fontSize="xs"
              letterSpacing="0.3em"
              textTransform="uppercase"
              color="brand.coral"
              fontWeight="600"
            >
              Our Values
            </Text>
          </HStack>
          <Heading
            fontFamily="'Playfair Display', serif"
            fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
            fontWeight="400"
            color="brand.cream"
            maxW="520px"
            lineHeight="1.2"
          >
            The Voice Behind
            <Text as="span" fontStyle="italic" color="brand.coral">
              {" "}
              Your Next Deal.
            </Text>
          </Heading>
        </MotionBox>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={0}>
          {cards.map((card, i) => (
            <MotionBox
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              borderLeft="1px solid rgba(46,46,46,0.8)"
              borderTop="1px solid rgba(46,46,46,0.8)"
              p={{ base: 8, md: 10 }}
              position="relative"
              overflow="hidden"
              role="group"
              cursor="default"
              _hover={{
                "& .hover-bg": { opacity: 1 },
                "& .card-number": { color: "brand.coral" },
              }}
            >
              <Box
                className="hover-bg"
                position="absolute"
                inset="0"
                background="linear-gradient(135deg, rgba(224,92,58,0.06) 0%, transparent 60%)"
                opacity={0}
                transition="opacity 0.4s ease"
                pointerEvents="none"
              />
              <Text
                className="card-number"
                fontSize="4xl"
                color="brand.graphite"
                mb={6}
                transition="color 0.3s"
                fontFamily="'Playfair Display', serif"
                lineHeight="1"
              >
                {String(i + 1).padStart(2, "0")}
              </Text>
              <Text
                fontSize="xs"
                letterSpacing="0.25em"
                textTransform="uppercase"
                color="brand.coral"
                mb={3}
                fontWeight="600"
              >
                {card.title}
              </Text>
              <Text
                color="rgba(245,240,235,0.58)"
                fontSize="sm"
                lineHeight="1.9"
              >
                {card.body}
              </Text>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}
